import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Client } from '@/types';
import { useForm } from 'react-hook-form';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Card, CardContent, CardHeader, CardTitle, CardFooter, CardDescription } from '@/components/ui/card';
import { X } from 'lucide-react';

interface InlineClientFormProps {
  client?: Client;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

const InlineClientForm: React.FC<InlineClientFormProps> = ({
  client,
  onSubmit,
  onCancel
}) => {
  const form = useForm({
    defaultValues: {
      name: client?.name || '',
    },
  });

  const handleSubmit = (values: { name: string }) => {
    onSubmit(values.name);
  };

  return (
    <Card className="w-full border shadow-sm">
      <CardHeader>
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>{client ? 'Edit Client' : 'Add New Client'}</CardTitle>
            <CardDescription>
              {client ? 'Update client details' : 'Add a new client to the system'}
            </CardDescription>
          </div>
          <Button variant="ghost" size="sm" onClick={onCancel} className="h-8 w-8 p-0">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Client Name</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter client name" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="flex justify-end gap-4 mt-8">
              <Button variant="outline" onClick={onCancel}>Cancel</Button>
              <Button type="submit">
                {client ? 'Update Client' : 'Create Client'}
              </Button>
            </div>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default InlineClientForm;
